/** A `FormState` with every field at its initial value. */
export function initialFormState() {
    return { values: {}, errors: {}, quantity: 1, discountCode: '', submitting: false };
}
// The implementation lives in `form.ts` and is re-exported from the package barrel. It is not
// imported here because `form.ts` imports these types — the split keeps the contract free of any
// dependency on its implementation, so the admin walker can be written against the types alone.
//# sourceMappingURL=builder.js.map